import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {Card, List, Button, Input, Row, Col, Icon, Switch, Spin} from 'antd'

import { changeWebhookUrlRequest, changeSecurityUrl } from 'redux/Ekko/actions'
import { createSecurityUrl, requestSecurityUrlList, requestDeleteSecurityUrl } from 'redux/SecurityUrl/actions'

class SettingsSecurity extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            urlTyping: '',
            requestDelete: false
        }
    }

    setRequestDelete() {
        this.setState(prevState => ({ requestDelete: !prevState.requestDelete }))
    }

    delete(security_url) {
        this.setRequestDelete()
        const security_url_id = security_url.id
        this.props.requestDeleteSecurityUrl(security_url_id)
    }

    onChangeUrlTyping(e) {
        this.setState({ urlTyping: e.target.value })
    }

    addUrl() {
        this.props.createSecurityUrl(this.state.urlTyping)
        this.setState(prevState => ({
            urlTyping: '',
        }))
    }

     disableAllowedUrl = value => {
        this.props.changeSecurityUrl(value)
    }

    onChangePage = page => {
        const { requestSecurityUrlList } = this.props

        requestSecurityUrlList(page)
    }

    render() {
        const { pagination: { page_size, page_number, total_entries } } = this.props
        const { allow_security_url } = this.props.currentApplication
        return (
            <Card title="Security">
                <Spin spinning={this.props.loadingCurrentApp} delay={100}>
                    <div style={{ paddingBottom: 16 }}>
                        <Row type="flex">
                            <Col lg={14} md={16} xs={20}>
                                Allow only specifics Url to access the application.
                            </Col>
                            <Col>
                                <Switch checked={allow_security_url} onChange={this.disableAllowedUrl} />
                            </Col>
                        </Row>
                    </div>
                    { allow_security_url === true & !this.props.loadingUrlList ? (
                        <List
                            bordered
                            dataSource={this.props.securityUrlList}
                            header={
                                <div>
                                    <span style={{ paddingBottom: 16, display: 'block' }}>Allowed domains</span>
                                    <Row>
                                        <Col md={12} xs={18}>
                                            <Input
                                                placeholder="*.exemple.com"
                                                onChange={e => this.onChangeUrlTyping(e)}
                                                value={this.state.urlTyping}
                                            />
                                        </Col>
                                        <Col md={3} xs={6}>
                                            <Button type="primary" onClick={() => this.addUrl()}>
                                                Add url
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            }
                            renderItem={item => (
                                <List.Item>
                                    <Row type="flex" style={{ flex: 1 }}>
                                        <Col span={22}>{item.url}</Col>
                                        <Col>
                                            <Icon type="delete" onClick={() => this.delete(item)} />
                                        </Col>
                                    </Row>
                                </List.Item>
                            )}
                            pagination={{
                                onChange: this.onChangePage,
                                pageSize: page_size,
                                current: page_number,
                                total: total_entries
                            }}
                        />
                    ) : null}
                </Spin>
            </Card>
        )
    }
}

const mapStateToProps = ({ ekko, securityurls }) => ({
    currentApplication: ekko.currentApp,
    securityUrlList: securityurls.urlList,
    loadingUrlList: securityurls.loadingUrlList,
    pagination: securityurls.pagination,
    loadingCurrentApp: ekko.loadingCurrentApp
})

const mapActionsToProps = dispatch => ({
    changeWebhookUrl: bindActionCreators(changeWebhookUrlRequest, dispatch),
    createSecurityUrl: bindActionCreators(createSecurityUrl, dispatch),
    requestSecurityUrlList: bindActionCreators(requestSecurityUrlList, dispatch),
    requestDeleteSecurityUrl: bindActionCreators(requestDeleteSecurityUrl, dispatch),
    changeSecurityUrl: bindActionCreators(changeSecurityUrl, dispatch),
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(SettingsSecurity)
